import AndroidStoreQr from '../../../assets/img/android-store-qr.png'
import AppleStoreQr from '../../../assets/img/apple-store-qr.png'

import { ReactComponent as AndroidStore } from 'src/assets/svg/android-store.svg'
import { ReactComponent as AppleStore } from 'src/assets/svg/apple-store.svg'

import './AppQrCodes.scss'

export const AppQrCodes = ({ qrSize = 100 }: { qrSize?: number }) => {
  return (
    <>
      <div className="download-app-card-image-container-qr">
        <img
          src={AppleStoreQr}
          alt="ios-store-qr-code"
          style={{ width: qrSize, height: qrSize }}
        />
        <AppleStore />
      </div>
      <div className="download-app-card-image-container-qr">
        <img
          src={AndroidStoreQr}
          alt="android-store-qr-code"
          style={{ width: qrSize, height: qrSize }}
        />
        <AndroidStore />
      </div>
    </>
  )
}
